import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { useNavigate } from 'react-router-dom';

export function CTASection() {
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation();
  const { ref: buttonsRef, isVisible: buttonsVisible } = useScrollAnimation();
  const navigate = useNavigate();

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @media (max-width: 768px) {
            .mobile-cta-section {
              padding-top: 40px !important;
              padding-bottom: 40px !important;
            }
            .mobile-cta-container {
              padding-left: 20px !important;
              padding-right: 20px !important;
              padding-top: 0 !important;
              padding-bottom: 0 !important;
            }
            .mobile-cta-inner {
              padding: 40px 20px !important;
              border-radius: 20px !important;
            }
            .mobile-cta-title {
              font-size: 28px !important;
              line-height: 36px !important;
            }
            .mobile-cta-subtitle {
              font-size: 14px !important;
              line-height: 20px !important;
              max-width: 100% !important;
              width: 100% !important;
            }
            .mobile-cta-buttons {
              flex-direction: column !important;
              gap: 12px !important;
              width: 100% !important;
            }
            .mobile-cta-button {
              width: 100% !important;
              justify-content: center !important;
            }
            .mobile-cta-gradient {
              width: 300px !important;
              height: 200px !important;
              left: 50% !important;
              transform: translateX(-50%) !important;
              top: -50px !important;
            }
          }
          `,
        }}
      />
      <div className="w-full py-[40px] bg-slate-950 flex justify-center items-center mobile-cta-section">
        <div className="w-full max-w-[1200px] px-[60px] py-10 bg-slate-950 flex flex-col justify-start items-start gap-14 mobile-cta-container">
          <div
            className="w-full px-14 py-12 relative rounded-[32px] outline outline-1 outline-offset-[-1px] flex flex-col justify-start items-center gap-4 overflow-hidden mobile-cta-inner"
            style={{
              backgroundColor: '#0A0E1A',
              outlineColor: 'rgba(255, 255, 255, 0.06)',
            }}
          >
            <div
              className="w-[500px] h-72 left-[290px] top-[-99px] absolute mobile-cta-gradient"
              style={{
                background:
                  'radial-gradient(circle, rgba(118, 188, 232, 0.2) 0%, rgba(118, 188, 232, 0) 60%)',
              }}
            />
            <div
              ref={contentRef}
              className={`transition-all duration-700 ease-out ${
                contentVisible
                  ? 'opacity-100 transform translate-y-0'
                  : 'opacity-0 transform translate-y-8'
              }`}
            >
              <div className="self-stretch flex flex-col justify-start items-center">
                <div
                  className="text-center justify-center text-5xl font-bold font-['Inter'] mobile-cta-title"
                  style={{ color: '#FAFAFA' }}
                >
                  Birlikte büyüyelim
                </div>
              </div>
              <div className="w-96 max-w-96 flex flex-col justify-start items-center mobile-cta-subtitle">
                <div
                  className="text-center justify-center text-base font-normal font-['Inter'] leading-7"
                  style={{ color: 'rgba(255, 255, 255, 0.5)' }}
                >
                  Dijital dönüşüm yolculuğunuzda yanınızda olmak
                  <br />
                  istiyoruz. Platformumuzu keşfedin.
                </div>
              </div>
            </div>
            <div
              ref={buttonsRef}
              className={`self-stretch pt-7 inline-flex justify-center items-start gap-3.5 mobile-cta-buttons transition-all duration-700 ease-out ${
                buttonsVisible
                  ? 'opacity-100 transform translate-y-0 scale-100'
                  : 'opacity-0 transform translate-y-8 scale-95'
              }`}
            >
              <button
                onClick={() => navigate('/contact')}
                className="px-11 py-4 rounded-2xl shadow-[0px_4px_24px_0px_rgba(118,188,232,0.25)] flex justify-start items-center gap-2.5 mobile-cta-button hover:opacity-90 transition-opacity"
                style={{ backgroundColor: '#76BCE8' }}
              >
                <span
                  className="text-center justify-center text-sm font-bold font-['Inter']"
                  style={{ color: '#0A0E1A' }}
                >
                  Ücretsiz Deneyin
                </span>
                <img
                  src="/icons/chevron-right.svg"
                  alt="chevron-right"
                  className="w-4 h-4"
                  style={{ filter: 'brightness(0)' }}
                />
              </button>
              <button
                onClick={() => navigate('/about')}
                className="px-9 py-4 rounded-2xl outline outline-1 outline-offset-[-1px] outline-white/5 flex justify-center items-center mobile-cta-button hover:bg-white/5 transition-colors"
              >
                <span
                  className="text-center justify-center text-sm font-semibold font-['Inter']"
                  style={{ color: 'rgba(255, 255, 255, 0.5)' }}
                >
                  Ekiple Tanışın
                </span>
              </button>
            </div>
            <div
              className="w-[1078px] h-px left-[1px] top-[1px] absolute"
              style={{
                background:
                  'linear-gradient(90deg, rgba(118, 188, 232, 0) 0%, rgba(118, 188, 232, 0.3) 50%, rgba(118, 188, 232, 0) 100%)',
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
